export default "__VITE_ASSET__DUPUmSV5__"